import { Typography } from '@mui/material';
import styled from 'styled-components';

const Container = styled.div`
  padding: 0px;
  margin-top: 16px;
`;

const Title = styled(Typography)`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #1c1c1e;
  letter-spacing: -0.4px;

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 12px;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 16px;

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;

const Label = styled(Typography)`
  font-size: 14px;
  margin-bottom: 4px;
  font-weight: 400;
  color: #1c1c1e;
  letter-spacing: -0.4px;

  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 6px;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const TagDiscount = styled.div`
  .percent-icon {
    margin-right: 4px;
    width: 16px;
    height: 16px;
  }
  margin-bottom: 4px;
  margin-left: 4px;
  background-color: #007aff14;
  color: #007aff;
  font-weight: 400;
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
`;

export { Container, Title, FormGroup, Label, Row, TagDiscount };
